import React, { useState } from 'react';
import { Chip, CircularProgress, makeStyles } from '@material-ui/core';
import {
  COLORS, PERIODS, PERIOD_SUFFIX, getDateRange,
} from './data';
import resumenRequest from '../../../requests/api/resume';

const useStyles = makeStyles(() => ({
  panel: {
    background: 'white',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.06)',
    overflow: 'hidden',
  },
  header: {
    padding: '12px 16px 10px',
    borderBottom: `1px solid ${COLORS.mist}`,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  title: { fontSize: 13.5, fontWeight: 700, color: COLORS.ink },
  chips: { display: 'flex', gap: 4, flexWrap: 'wrap' },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    gap: 10,
    borderBottom: '1px solid #f2f5f7',
    '&:last-child': { borderBottom: 'none' },
  },
  icon: {
    width: 30,
    height: 30,
    borderRadius: 7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    flexShrink: 0,
  },
  label: {
    flex: 1, fontSize: 13, fontWeight: 500, color: COLORS.ink,
  },
  pct: {
    fontSize: 11.5, color: COLORS.slate,
  },
  val: {
    fontSize: 13, fontWeight: 700, color: COLORS.ink, minWidth: 72, textAlign: 'right',
  },
  loadingWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 16px',
  },
}));

export default function PaymentPanel({ pagos: initialPagos, clientId }) {
  const classes = useStyles();
  const [period, setPeriod] = useState('today');
  const [pagos, setPagos] = useState(initialPagos);
  const [loading, setLoading] = useState(false);

  const handlePeriodChange = async (key) => {
    if (key === period) return;
    setPeriod(key);
    const { startDate, endDate } = getDateRange(key);
    setLoading(true);
    try {
      const response = await resumenRequest.getPayments(clientId, startDate, endDate);
      if (response.success) setPagos(response.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <div className={classes.titleRow}>
          <span className={classes.title}>
            Cómo te pagaron — {PERIOD_SUFFIX[period]}
          </span>
        </div>
        <div className={classes.chips}>
          {PERIODS.map((p) => (
            <Chip
              key={p.key}
              label={p.label}
              size="small"
              onClick={() => handlePeriodChange(p.key)}
              color={period === p.key ? 'primary' : 'default'}
              variant={period === p.key ? 'default' : 'outlined'}
            />
          ))}
        </div>
      </div>
      {loading ? (
        <div className={classes.loadingWrap}>
          <CircularProgress size={22} />
        </div>
      ) : (
        pagos && pagos.map((p) => (
          <div key={p.label} className={classes.row}>
            <div className={classes.icon} style={{ background: p.bg }}>{p.icon}</div>
            <span className={classes.label}>{p.label}</span>
            <span className={classes.pct}>{p.pct}</span>
            <span className={classes.val}>{p.val}</span>
          </div>
        ))
      )}
    </div>
  );
}
